import React, { useState } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { Form, Input, Button, Row, Col,Alert  } from 'antd';
import { LoadingOutlined, MailOutlined } from '@ant-design/icons';
import './ForgetPassword.css';
import { forgetPassword } from "../../../Actions/api";

function ForgetPassword() {
  const layout = {
    labelCol: {
        span: 12,
    },
    wrapperCol: {
        span: 24,
    },
  };


  const [loading, setLoading] = useState(false);
  const { message } = useSelector(state => state.message);
  const dispatch = useDispatch();

  const onFinish = (e) => {
        setLoading(true);
        dispatch(forgetPassword(e.email))
        .then(() => {
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
  }

  return (
    <div className="FP-container" justify="center">
            <div className="FP-title">Forget Password</div>
            <div className="sub-signin-title">*Enter your email address and we will send you a link to reset your password.</div>
            {message && 
            (
                <Row gutter={24}>
                    <Col xs={24} sm={24} md={24} lg={6} xl={6} justify="center"></Col>
                    <Col xs={24} sm={24} md={24} lg={12} xl={12} justify="center">
                    {message && (
                        <div>
                              {message[0] === true ? <Alert message="If this email is valid, you will be receiving an email to reset your password. Please check your junk mail if you didn't receive the email." type="success" /> : <Alert message="Something Got Error" type="error" />}
                        </div>
                    )}
                    </Col>
                </Row>
            )
            }
            <Form
                {...layout}
                layout="vertical"
                name="basic"
                onFinish={onFinish}
                className="FP_form"
            >
                <Row gutter={24}>
                    <Col xs={24} sm={24} md={24} lg={6} xl={6} justify="center"></Col>
                    <Col xs={24} sm={24} md={24} lg={12} xl={12} justify="center">
                    <Form.Item
                        label={<label className="label_FP">Email</label>}
                        name="email"
                        rules={[
                            {
                                type: 'email',
                                message: 'The input is not valid E-mail!',
                            },
                            {
                                required: true,
                                message: 'Please input your email address!',
                            },
                        ]}
                    >
                        <Input addonBefore={<MailOutlined />} size="large" placeholder=""/>
                        </Form.Item>
                    </Col>
                </Row>
                <br/>
                <Form.Item style={{textAlign:"center"}}>
                    <Button type="primary" htmlType="submit" size="large" className="button_FP">
                        {loading && (
                            <LoadingOutlined /> 
                        )}
                        Send
                    </Button>
                </Form.Item>
            </Form>
        </div>
  );
}

export default ForgetPassword;